const CUSTOM_MAIN_WISHLIST_OPTIMISTIC_DISABLE_MS = 500;

function disableMainWishlistElementTemporarily(element, duration = CUSTOM_MAIN_WISHLIST_OPTIMISTIC_DISABLE_MS) {
  if (!element) return;

  const canUseDisabled = 'disabled' in element;
  if (!element._multilikesDisableState) {
    element._multilikesDisableState = {
      pointerEvents: element.style.pointerEvents,
      opacity: element.style.opacity
    };
  }

  if (canUseDisabled) {
    element.disabled = true;
  } else {
    element.style.pointerEvents = 'none';
    element.style.opacity = '0.5';
  }

  if (element._multilikesDisableTimer) {
    clearTimeout(element._multilikesDisableTimer);
  }

  element._multilikesDisableTimer = setTimeout(() => {
    if (canUseDisabled) {
      element.disabled = false;
    } else {
      element.style.pointerEvents = element._multilikesDisableState.pointerEvents;
      element.style.opacity = element._multilikesDisableState.opacity;
    }
    element._multilikesDisableTimer = null;
    element._multilikesDisableState = null;
  }, duration);
}

const WishlistUtils = {
  getArrowSvg(direction) {
    const rotate = direction === 'left' ? 'style="transform: rotate(180deg)"' : '';
    return `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ${rotate}>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.7676 11.8159C5.53792 11.577 5.54537 11.1972 5.78423 10.9675L8.93443 8L5.78423 5.0325C5.54537 4.80282 5.53792 4.423 5.7676 4.18413C5.99727 3.94527 6.3771 3.93782 6.61596 4.1675L10.216 7.5675C10.3336 7.68062 10.4001 7.83679 10.4001 8C10.4001 8.16321 10.3336 8.31938 10.216 8.4325L6.61596 11.8325C6.3771 12.0622 5.99727 12.0547 5.7676 11.8159Z" fill="currentColor"/>
    </svg>`;
  },

  createPageLink(pageNumber, text, isDisabled = false, isActive = false) {
    const li = document.createElement('li');
    li.className = 'wishlist-pagination__item';
    
    const a = document.createElement('a');
    a.href = '#';
    a.className = 'wishlist-pagination__link';
    a.dataset.page = pageNumber.toString();

    if (text === 'prev' || text === '‹' || text === '<') {
      a.innerHTML = this.getArrowSvg('left');
      a.classList.add('wishlist-pagination__arrow');
    } else if (text === 'next' || text === '›' || text === '>') {
      a.innerHTML = this.getArrowSvg('right');
      a.classList.add('wishlist-pagination__arrow');
    } else {
      a.textContent = text;
    }

    if (isDisabled) {
      a.classList.add('disabled');
    }
    if (isActive) {
      a.classList.add('is-active');
    }

    li.appendChild(a);
    return li;
  },

  createPaginationElements(container, loadingText) {
    const loadingElement = document.createElement('div');
    loadingElement.className = 'wishlist-loading';
    loadingElement.style.display = 'none';
    loadingElement.textContent = loadingText || '読込中...';
    
    const paginationElement = document.createElement('div');
    paginationElement.className = 'wishlist-pagination';
    
    container.appendChild(loadingElement);
    container.appendChild(paginationElement);
    
    return { loadingElement, paginationElement };
  },

  extractNumericId(gid) {
    if (!gid) return gid;
    const match = gid.match(/\/(\d+)$/);
    return match ? match[1] : gid;
  },

  formatDate(dateString) {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } catch (error) {
      return dateString;
    }
  }
};

class WishlistSection {
  static sections = new WeakMap();
  
  constructor(container) {
    this.container = container;
    this.blockId = container.dataset.blockId;
    this.objectType = container.dataset.objectType;
    
    this.currentPage = 1;
    this.totalPages = 0;
    this.pageInfo = {
      hasNextPage: false,
      hasPreviousPage: false,
      startCursor: null,
      endCursor: null
    };
    this.pageCursors = {};
    this.paginationType = 'simple';
    
    const configScript = document.querySelector(`script[data-wishlist-config="${this.blockId}"]`);
    if (!configScript) {
      console.error(`Config not found for object type: ${this.blockId}`);
      this.showError('設定が見つかりません');
      return;
    }
    try {
      const config = JSON.parse(configScript.textContent);
      
      this.customerId = config.customerId;
      this.defaultUrl = config.defaultUrl;
      
      if (config.texts === "global" && window.multilikesConfig?.texts) {
        this.texts = window.multilikesConfig.texts;
      } else if (typeof config.texts === 'object') {
        this.texts = config.texts;
      } else {
        this.texts = {
          detail_url_text: '詳細ページへ',
          loading: '読込中..',
          empty: 'お気に入りがありません',
          error: 'お気に入り一覧の読み込み中にエラーが発生しました。<br>再読み込みを行い、再度お試し下さい。',
          addToFavorites: '♡ お気に入り',
          removeFavorites: '♥ お気に入り済み'
        };
      }
      const showFavoritesSetting = config.showFavoritesCount;
      this.showFavoritesCount = showFavoritesSetting === true || showFavoritesSetting === 'true';
      this.mode = config.mode;
      this.layout = config.layout;
      this.itemsPerPage = config.itemsPerPage || 60;
    } catch (error) {
      console.error('Invalid JSON config:', error);
      this.showError('設定の形式が正しくありません');
      return;
    }
    
    this.gridElement = container.querySelector('.wishlist-grid');
    this.createPaginationElements();
    
    this.metaobjects = [];
    this.favoritedIds = [];
    this.loading = false;
    this.loaded = false;
    this.lastUpdated = null;
    
    this.setupEventListeners();
    this.init();
  }
  
  createPaginationElements() {
    const elements = WishlistUtils.createPaginationElements(this.container, this.texts.loading);
    this.loadingElement = elements.loadingElement;
    this.paginationElement = elements.paginationElement;
  }

  showLoading() {
    if (this.loadingElement) this.loadingElement.style.display = 'block';
    if (this.paginationElement) this.paginationElement.style.display = 'none';
  }

  hideLoading() {
    if (this.loadingElement) this.loadingElement.style.display = 'none';
    if (this.paginationElement) this.paginationElement.style.display = 'flex';
  }
  
  static initByObjectType(container) {
    if (!container) return null;
    const objectType = container.dataset.objectType;
    if (!objectType) return null;
    if (container.dataset.initialized === 'true') {
      return WishlistSection.sections.get(container);
    }
    container.dataset.initialized = 'true';
    const section = new WishlistSection(container);
    WishlistSection.sections.set(container, section);
    return section;
  }
  
  static initAllSections() {
    document.querySelectorAll('metaobject-wishlist').forEach(WishlistSection.initByObjectType);
  }
  
  static getSectionByObjectType(objectType) {
    for (const [, section] of WishlistSection.sections) {
      if (section.objectType === objectType) return section;
    }
    return null;
  }
  
  static getSectionByContainer(container) {
    return WishlistSection.sections.get(container) || null;
  }
  
  showError(message) {
    this.hideLoading();
    if (this.gridElement) {
      this.gridElement.innerHTML = message;
    }
  }
  
  setupEventListeners() {
    this.gridElement?.addEventListener('click', (e) => {
      if (e.target.classList.contains('wishlist-item__favorite-btn')) {
        e.preventDefault();
        this.toggleFavorite(e.target.dataset.objectId);
      } else if (e.target.classList.contains('wishlist-item__favorite-remove-btn')) {
        e.preventDefault();
        this.toggleFavorite(e.target.dataset.objectId, 'remove');
      }
    });

    this.paginationElement?.addEventListener('click', (e) => {
        e.preventDefault();
      const link = e.target.closest('a');
      if (link && !link.classList.contains('disabled')) {
        const page = parseInt(link.dataset.page);
        if (page && page !== this.currentPage) this.goToPage(page);
      }
    });
  }
  
  init() {
    this.fetchWishlistData();
  }

  setText(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  parseFavoriteCountValue(value) {
    if (value === null || value === undefined) {
      return null;
    }

    if (typeof value === 'number') {
      return Number.isNaN(value) ? null : Math.max(0, value);
    }

    if (typeof value === 'string' && value.trim() !== '') {
      const parsed = Number(value);
      return Number.isNaN(parsed) ? null : Math.max(0, parsed);
    }

    return null;
  }

  getFavoriteCountFromFields(fields) {
    if (!Array.isArray(fields)) {
      return null;
    }

    const favoriteField = fields.find(field => field.key === 'favorite_count');
    if (!favoriteField) {
      return null;
    }

    const rawValue = favoriteField.value ?? favoriteField.jsonValue ?? null;
    return this.parseFavoriteCountValue(rawValue);
  }

  setFavoriteCountForItem(item, count) {
    const sanitized = this.parseFavoriteCountValue(count);

    if (typeof sanitized === 'number') {
      item.favoriteCount = sanitized;
      return item.favoriteCount;
    }

    if (typeof item.favoriteCount === 'number') {
      return item.favoriteCount;
    }

    const initialCount = this.getFavoriteCountFromFields(item.fields);
    item.favoriteCount = initialCount !== null ? initialCount : null;
    return item.favoriteCount;
  }

  formatFavoriteButtonLabel(isFavorited, favoriteCount) {
    let label = isFavorited
      ? (this.texts.removeFavorites || 'お気に入りから削除')
      : (this.texts.addToFavorites || 'お気に入りに追加');

    if (this.showFavoritesCount && favoriteCount !== null && favoriteCount !== undefined) {
      label += ` (${favoriteCount})`;
    }

    return label;
  }

  adjustFavoriteCountAfterToggle(metaobject, wasFavorited, isFavorited) {
    if (!metaobject) {
      return null;
    }

    let favoriteCount = typeof metaobject.favoriteCount === 'number'
      ? metaobject.favoriteCount
      : this.getFavoriteCountFromFields(metaobject.fields);

    if (favoriteCount === null || favoriteCount === undefined) {
      favoriteCount = 0;
    }

    if (wasFavorited === isFavorited) {
      return favoriteCount;
    }

    favoriteCount = isFavorited
      ? favoriteCount + 1
      : Math.max(0, favoriteCount - 1);

    metaobject.favoriteCount = favoriteCount;
    return favoriteCount;
  }

  resolveFavoriteCountFromPayload(payload) {
    if (!payload) {
      return null;
    }

    const count = payload.favoriteCount ?? payload.updatedCount;
    return this.parseFavoriteCountValue(count);
  }

  setFavoritedState(objectId, isFavorited) {
    const index = this.favoritedIds.indexOf(objectId);

    if (isFavorited && index === -1) {
      this.favoritedIds.push(objectId);
    } else if (!isFavorited && index > -1) {
      this.favoritedIds.splice(index, 1);
    }
  }
  
  createWishlistItemElement(item) {
    const needsWrapper = this.layout === 'mypage' && this.mode === 'customer_wishlist' && this.objectType === 'artist';
    
    const isStore = this.objectType === 'multilikes_store';
    
    const needsWrapperForButton = this.mode !== 'customer_wishlist' && (this.objectType === 'artist' || this.objectType === 'multilikes_store');
    
    const itemElement = document.createElement('div');
    itemElement.className = 'wishlist-item';
    if (isStore) {
      itemElement.classList.add('wishlist-item--store');
    } else if (this.objectType === 'artist') {
      itemElement.classList.add('wishlist-item--brand-only');
    }
    itemElement.dataset.itemId = item.id;
    
    let wrapperElement = null;
    if (needsWrapper || needsWrapperForButton) {
      wrapperElement = document.createElement('div');
      wrapperElement.className = 'wishlist-item-wrapper';
    }
    
    const imageContainer = document.createElement('div');
    imageContainer.className = 'wishlist-item__image';
    
    const imageField = item.fields ? item.fields.find(field => field.key === 'image') : null;
    const logoField = item.fields ? item.fields.find(field => field.key === 'logo') : null;
    const imageUrl = (imageField && imageField.value) || (logoField && logoField.value) || null;
    const isBrandType = this.objectType === 'artist';
    
    if (imageUrl && typeof imageUrl === 'string') {
      const img = document.createElement('img');
      img.src = imageUrl;
      const nameField = isStore ? (item.fields ? item.fields.find(field => field.key === 'name') : null) : null;
      const altText = nameField && nameField.value ? nameField.value : (item.displayName || '');
      img.alt = this.setText(altText) || '';
      imageContainer.appendChild(img);
      itemElement.appendChild(imageContainer);
    } else if (isBrandType) {
      const placeholder = document.createElement('div');
      placeholder.className = 'wishlist-item__image-placeholder';
      placeholder.textContent = item.displayName || '';
      imageContainer.appendChild(placeholder);
      itemElement.appendChild(imageContainer);
    }

    const infoContainer = document.createElement('div');
    infoContainer.className = 'wishlist-item__information';
    
    const isBrand = this.objectType === 'artist';
    
    const displayName = isStore ? (() => {
      const nameField = item.fields ? item.fields.find(field => field.key === 'name') : null;
      return nameField && nameField.value ? nameField.value : item.displayName;
    })() : item.displayName;
    
    let titleElement = null;
    let descriptionElement = null;
    if (displayName) {
      const title = document.createElement('h3');
      title.className = 'wishlist-item__title';
      // ロゴがある場合はロゴ画像を表示
      const logoUrl = logoField && logoField.value ? logoField.value : null;

      if (logoUrl && typeof logoUrl === 'string') {
        const logoImg = document.createElement('img');
        logoImg.src = logoUrl;
        logoImg.alt = item.displayName;
        logoImg.className = 'wishlist-item__logo';
        title.appendChild(logoImg);
      }else{
        title.textContent = displayName;
      }
      infoContainer.appendChild(title);
    }

    const shouldShowStoreInfo = isStore || this.layout !== 'mypage';
    
    let brandLinksContainer = null;

    // 店舗/ブランドの概要
    const descriptionField = item.fields ? item.fields.find(field => field.key === 'description') : null;
    if (descriptionField && descriptionField.value) {
      const description = document.createElement('div');
      description.className = 'wishlist-item__description';
      description.textContent = descriptionField.value;
      infoContainer.appendChild(description);
    }

    if(shouldShowStoreInfo){
      const addressField = item.fields ? item.fields.find(field => field.key === 'address') : null;
      if (addressField && addressField.value) {
        const address = document.createElement('div');
        address.className = 'wishlist-item__address';
        const addressLabel = document.createElement('span');
        addressLabel.className = 'wishlist-item__label';
        addressLabel.textContent = '住所';
        const addressText = document.createElement('span');
        addressText.textContent = addressField.value;
        address.appendChild(addressLabel);
        address.appendChild(addressText);
        infoContainer.appendChild(address);
      }

      const openingHoursField = item.fields ? item.fields.find(field => field.key === 'opening_hours') : null;
      if (openingHoursField && openingHoursField.value) {
        const openingHours = document.createElement('div');
        openingHours.className = 'wishlist-item__opening-hours';
        const hoursLabel = document.createElement('span');
        hoursLabel.className = 'wishlist-item__label';
        hoursLabel.textContent = '営業時間';
        const hoursText = document.createElement('span');
        hoursText.textContent = openingHoursField.value;
        openingHours.appendChild(hoursLabel);
        openingHours.appendChild(hoursText);
        infoContainer.appendChild(openingHours);
      }

      const closedDaysField = item.fields ? item.fields.find(field => field.key === 'closed_days') : null;
      if (closedDaysField && closedDaysField.value) {
        const closedDays = document.createElement('div');
        closedDays.className = 'wishlist-item__closed-days';
        const closedLabel = document.createElement('span');
        closedLabel.className = 'wishlist-item__label';
        closedLabel.textContent = '定休日';
        const closedText = document.createElement('span');
        closedText.textContent = closedDaysField.value;
        closedDays.appendChild(closedLabel);
        closedDays.appendChild(closedText);
        infoContainer.appendChild(closedDays);
      }

      const notesField = item.fields ? item.fields.find(field => field.key === 'notes') : null;
      if (notesField && notesField.value) {
        const notes = document.createElement('div');
        notes.className = 'wishlist-item__notes';
        const notesLabel = document.createElement('span');
        notesLabel.className = 'wishlist-item__label';
        notesLabel.textContent = '特記事項';
        const notesText = document.createElement('span');
        notesText.textContent = notesField.value;
        notes.appendChild(notesLabel);
        notes.appendChild(notesText);
        infoContainer.appendChild(notes);
      }

      if (!isBrand) {
      const linksContainer = document.createElement('div');
      linksContainer.className = 'wishlist-item__links';
      let hasLinks = false;

        const detailUrlField = item.fields ? item.fields.find(field => field.key === 'detail_url') : null;
        if (detailUrlField && detailUrlField.value) {
          const detailLink = document.createElement('a');
          detailLink.href = detailUrlField.value;
          detailLink.className = 'wishlist-item__link';
          detailLink.textContent = this.texts.view_details || this.texts.detail_url_text || '詳細を見る';
          detailLink.target = '_blank';
          detailLink.rel = 'noopener noreferrer';
          linksContainer.appendChild(detailLink);
          hasLinks = true;
      }

        if (isStore) {
      const googleMapUrlField = item.fields ? item.fields.find(field => field.key === 'google_map_url') : null;
      if (googleMapUrlField && googleMapUrlField.value) {
        const mapLink = document.createElement('a');
        mapLink.href = googleMapUrlField.value;
            mapLink.className = 'wishlist-item__link wishlist-item__link--google-map';
            mapLink.textContent = this.texts.google_map || 'Googleマップ';
        mapLink.target = '_blank';
        mapLink.rel = 'noopener noreferrer';
        linksContainer.appendChild(mapLink);
        hasLinks = true;
          }
      }

      if (hasLinks) {
        infoContainer.appendChild(linksContainer);
        }
      }
    }
    
    if (isBrand) {
      const detailUrlField = item.fields ? item.fields.find(field => field.key === 'detail_url') : null;
      if (detailUrlField && detailUrlField.value) {
        brandLinksContainer = document.createElement('div');
        brandLinksContainer.className = 'wishlist-item__links wishlist-item__links--outside';
        const detailLink = document.createElement('a');
        detailLink.href = detailUrlField.value;
        detailLink.className = 'wishlist-item__link';
        detailLink.textContent = this.texts.view_details || this.texts.detail_url_text || '詳細を見る';
        detailLink.target = '_blank';
        detailLink.rel = 'noopener noreferrer';
        brandLinksContainer.appendChild(detailLink);
      }
    }
    
    if (infoContainer.children.length > 0) {
      itemElement.appendChild(infoContainer);
    }
    
    if(this.layout === 'mypage' && this.mode === 'customer_wishlist'){
      const removeButton = this.createRemoveFavoriteButton(item);
      itemElement.appendChild(removeButton);

      if (!isStore) {
        const detailUrlField = item.fields ? item.fields.find(field => field.key === 'detail_url') : null;
        if (detailUrlField && detailUrlField.value) {
          const detailLink = document.createElement('a');
          detailLink.href = detailUrlField.value;
          detailLink.className = 'wishlist-item__link';
          detailLink.textContent = this.texts.view_details || this.texts.detail_url_text || '詳細を見る';
          detailLink.target = '_blank';
          detailLink.rel = 'noopener noreferrer';
          
          if (wrapperElement) {
            wrapperElement.appendChild(itemElement);
            if (isBrand) {
              if (titleElement) {
                wrapperElement.appendChild(titleElement);
              }
              if (descriptionElement) {
                wrapperElement.appendChild(descriptionElement);
              }
            }
            wrapperElement.appendChild(detailLink);
            return wrapperElement;
          } else {
            infoContainer.appendChild(detailLink);
          }
        } else if (wrapperElement) {
          wrapperElement.appendChild(itemElement);
          if (isBrand) {
            if (titleElement) {
              wrapperElement.appendChild(titleElement);
            }
            if (descriptionElement) {
              wrapperElement.appendChild(descriptionElement);
            }
          }
          return wrapperElement;
        }
      }
    } else if(this.mode === 'customer_wishlist'){
      const button = this.createRemoveFavoriteButton(item);
      infoContainer.appendChild(button);
    }else{
      const button = this.createFavoriteButton(item);
      if (isBrand || isStore) {
        if (wrapperElement) {
          wrapperElement.appendChild(itemElement);
          if (isBrand) {
            if (titleElement) {
              wrapperElement.appendChild(titleElement);
            }
            if (descriptionElement) {
              wrapperElement.appendChild(descriptionElement);
            }
            if (brandLinksContainer) {
              wrapperElement.appendChild(brandLinksContainer);
            }
          }
          wrapperElement.appendChild(button);
          return wrapperElement;
        } else {
          itemElement.appendChild(button);
        }
      } else {
      infoContainer.appendChild(button);
      }
    }
    
    if (wrapperElement) {
      wrapperElement.appendChild(itemElement);
      if (isBrand) {
        if (titleElement) {
          wrapperElement.appendChild(titleElement);
        }
        if (descriptionElement) {
          wrapperElement.appendChild(descriptionElement);
        }
        if (brandLinksContainer) {
          wrapperElement.appendChild(brandLinksContainer);
        }
      }
      return wrapperElement;
    }
    
    return itemElement;
  }
  
  createFavoriteButton(item) {
    const button = document.createElement('button');
    button.className = 'wishlist-item__favorite-btn';
    button.dataset.objectId = item.id;
    
    const isFavorited = item.isInWishlist || false;
    const favoriteCount = this.setFavoriteCountForItem(item, item.favoriteCount);
    
    if (favoriteCount !== null && favoriteCount !== undefined) {
      button.dataset.favoriteCount = String(favoriteCount);
    }
    
    if (isFavorited) {
      button.classList.add('is-active');
    }
    
    button.textContent = this.formatFavoriteButtonLabel(isFavorited, favoriteCount);
    button.setAttribute('aria-pressed', isFavorited.toString());
    button.setAttribute('aria-label', `${item.displayName}を${isFavorited ? '削除' : '追加'}`);
    
    return button;
  }

  createRemoveFavoriteButton(item) {
    const button = document.createElement('button');
    button.className = 'wishlist-item__favorite-remove-btn';
    button.dataset.objectId = item.id;
    
    button.setAttribute('aria-label', `${item.displayName}を削除`);
    
    return button;
  }

  updateButtonUI(button, isFavorited, itemDisplayName, favoriteCount = null) {
    if (!button) return;
    
    if (isFavorited) {
      button.classList.add('is-active');
    } else {
      button.classList.remove('is-active');
    }
    
    const sanitizedCount = favoriteCount !== null && favoriteCount !== undefined
      ? this.parseFavoriteCountValue(favoriteCount)
      : this.parseFavoriteCountValue(button.dataset.favoriteCount);

    if (sanitizedCount !== null && sanitizedCount !== undefined) {
      button.dataset.favoriteCount = String(sanitizedCount);
    } else {
      delete button.dataset.favoriteCount;
    }

    button.textContent = this.formatFavoriteButtonLabel(isFavorited, sanitizedCount);
    
    button.setAttribute('aria-pressed', isFavorited.toString());
    button.setAttribute('aria-label', `${itemDisplayName}を${isFavorited ? '削除' : '追加'}`);
  }
  
  render() {
    if (!this.gridElement) return;
    
    this.gridElement.innerHTML = '';
    
    this.updateTotalCount();
    
    if (this.metaobjects.length === 0) {
      this.gridElement.innerHTML = this.texts.empty;
      this.renderPagination();
      return;
    }

    this.metaobjects.forEach(item => {
      const itemElement = this.createWishlistItemElement(item);
      this.gridElement.appendChild(itemElement);
    });

    this.renderPagination();
  }

  updateTotalCount() {
    const contentWrapper = this.container.closest('.customer-wishlist-content');
    if (!contentWrapper) return;
    let countElement = contentWrapper.querySelector('.customer-wishlist-count');
    if (!countElement) {
      countElement = document.createElement('div');
      countElement.className = 'customer-wishlist-count';
      contentWrapper.insertBefore(countElement, this.container);
    }
    countElement.textContent = `登録数: ${this.totalCount || 0}件`;
  }

  renderPagination() {
    if (!this.paginationElement) return;
    
    this.paginationElement.innerHTML = '';
    
    if (this.totalPages <= 1) return;

    if (this.paginationType === 'simple') {
      this.renderSimplePagination();
    } else {
      this.renderDetailedPagination();
    }
  }

  renderDetailedPagination() {
    const ul = document.createElement('ul');
    ul.className = 'wishlist-pagination__list';

    const prevButton = this.createPageLink(this.currentPage - 1, '← 前へ', this.currentPage === 1);
    ul.appendChild(prevButton);

    const pagesToShow = [];
    
    if (this.currentPage !== 1) {
      pagesToShow.push(1);
    }
    
    if (this.currentPage > 2) {
      if (this.currentPage > 3) {
        pagesToShow.push('...');
      }
      pagesToShow.push(this.currentPage - 1);
    }
    
    pagesToShow.push(this.currentPage);
    
    if (this.currentPage < this.totalPages - 1) {
      pagesToShow.push(this.currentPage + 1);
      if (this.currentPage < this.totalPages - 2) {
        pagesToShow.push('...');
      }
    }
    
    if (this.currentPage !== this.totalPages && this.totalPages > 1) {
      pagesToShow.push(this.totalPages);
    }

    pagesToShow.forEach(page => {
      if (page === '...') {
        ul.appendChild(this.createDots());
      } else {
        ul.appendChild(this.createPageLink(page, page.toString(), false, page === this.currentPage));
      }
    });

    const nextButton = this.createPageLink(this.currentPage + 1, '次へ →', this.currentPage === this.totalPages);
    ul.appendChild(nextButton);

    this.paginationElement.appendChild(ul);
  }

  renderSimplePagination() {
    const ul = document.createElement('ul');
    ul.className = 'wishlist-pagination__list wishlist-pagination__list--simple';

    const prevButton = this.createPageLink(this.currentPage - 1, '‹', this.currentPage === 1);
    ul.appendChild(prevButton);

    const pageInfo = document.createElement('li');
    pageInfo.className = 'wishlist-pagination__item wishlist-pagination__page-info';
    const startItem = (this.currentPage - 1) * this.itemsPerPage + 1;
    const endItem = Math.min(this.currentPage * this.itemsPerPage, this.totalCount || 0);
    const totalText = this.texts.paginationTotal || '件中';
    pageInfo.textContent = `${startItem}-${endItem} / ${this.totalCount || 0}${totalText}`;
    ul.appendChild(pageInfo);

    const nextButton = this.createPageLink(this.currentPage + 1, '>', this.currentPage === this.totalPages);
    ul.appendChild(nextButton);

    this.paginationElement.appendChild(ul);
  }

  createPageLink(pageNumber, text, isDisabled = false, isActive = false) {
    return WishlistUtils.createPageLink(pageNumber, text, isDisabled, isActive);
  }

  createDots() {
    const li = document.createElement('li');
    li.className = 'wishlist-pagination__item wishlist-pagination__dots';
    li.textContent = '...';
    return li;
  }
  
  async fetchWishlistData(renderAfterFetch = true, cursor = null) {
    if (this.loading) return;
    
    this.loading = true;
    
    if (!this.gridElement) {
      this.loading = false;
      return;
    }

    this.showLoading();

    try {
      let requestUrl = this.defaultUrl;
      const queryParams = new URLSearchParams();
      if (this.customerId) {
        queryParams.append('customer_id', this.customerId);
      }
      if (this.objectType) {
        queryParams.append('metaobject_type', this.objectType);
      }
      queryParams.append('limit', this.itemsPerPage.toString());
      if (cursor) {
        queryParams.append('after', cursor);
      }
      if (this.mode === 'customer_wishlist') {
        queryParams.append('mode', 'customer_wishlist');
      }
      
      const queryString = queryParams.toString();
      if (queryString) {
        requestUrl += (requestUrl.includes('?') ? '&' : '?') + queryString;
      }

      const response = await fetch(requestUrl);
      const result = await response.json();

      if (renderAfterFetch && result.no_setting) {
        this.hideLoading();
        this.gridElement.innerHTML = this.texts.empty;
        this.totalPages = 0;
        this.renderPagination();
        this.loading = false;
        return;
      }

      this.metaobjects = (result.data || []).map(item => {
        const cloned = { ...item };
        if (typeof cloned.favoriteCount !== 'number') {
          cloned.favoriteCount = this.getFavoriteCountFromFields(cloned.fields);
        }
        return cloned;
      });
      this.totalCount = result.total || 0;
      this.totalPages = Math.ceil(this.totalCount / this.itemsPerPage);
      
      if (cursor && this.metaobjects.length === 0 && this.currentPage > 1) {
        this.handleCursorError();
        return;
      }
      
      if (result.pageInfo) {
        this.pageInfo = result.pageInfo;
        
        if (result.pageInfo.endCursor && this.currentPage < this.totalPages) {
          this.pageCursors[this.currentPage + 1] = result.pageInfo.endCursor;
        }
        
        if (result.pageInfo.startCursor && this.currentPage > 1) {
          if (!this.pageCursors[this.currentPage]) {
            this.pageCursors[this.currentPage] = cursor;
          }
        }
      }
      
      this.favoritedIds = this.metaobjects
        .filter(item => item.isInWishlist)
        .map(item => item.id);
      this.loaded = true;
      this.lastUpdated = new Date();
      
      this.hideLoading();
      
      if (renderAfterFetch) {
        this.render();
      }

    } catch (error) {
      console.error(`Error fetching wishlist data for object type ${this.objectType}:`, error);
      this.hideLoading();
      this.gridElement.innerHTML = this.texts.error;
    } finally {
      this.loading = false;
    }
  }
  
  /**
   * お気に入り状態をトグル
   * @param {string} objectId - オブジェクトID
   * @param {string} fixAction - アクション（add, remove）
   */
  async toggleFavorite(objectId, fixAction ) {
    if (!this.customerId) {
      // 未ログインの理由を示してから誘導する。
      // 以前はここで alert() も出していたが、モーダルが同じことを伝えるため廃止した。
      if (typeof window.requireLoginForWishlist === 'function') {
        window.requireLoginForWishlist();
        return;
      }
      window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.href);
      return;
    }

    const button = this.container.querySelector(`[data-object-id="${objectId}"]`);
    if (!button) return;

    const isCurrentlyFavorited = button.classList.contains('is-active');
    const isRemoveAction = fixAction === 'remove';
    const nextFavoriteState = !isCurrentlyFavorited;
    const metaobject = this.metaobjects
      ? this.metaobjects.find(item => item.id === objectId)
      : null;
    const metaobjectDisplayName = metaobject?.displayName || '';
    const previousFavoriteCount = metaobject
      ? (typeof metaobject.favoriteCount === 'number'
        ? metaobject.favoriteCount
        : this.getFavoriteCountFromFields(metaobject.fields))
      : this.parseFavoriteCountValue(button.dataset.favoriteCount);
    const seq = isRemoveAction ? null : ((button._multilikesRequestSeq || 0) + 1);

    if (!isRemoveAction) {
      button._multilikesRequestSeq = seq;
      this.setFavoritedState(objectId, nextFavoriteState);
      let updatedFavoriteCount = previousFavoriteCount;
      if (metaobject) {
        updatedFavoriteCount = this.adjustFavoriteCountAfterToggle(
          metaobject,
          isCurrentlyFavorited,
          nextFavoriteState
        );
        metaobject.isInWishlist = nextFavoriteState;
      }
      this.lastUpdated = new Date();
      this.updateButtonUI(
        button,
        nextFavoriteState,
        metaobjectDisplayName,
        updatedFavoriteCount
      );
    }

    disableMainWishlistElementTemporarily(button);

    const favoriteButtons = this.container.querySelectorAll('.wishlist-item__favorite-btn');
    favoriteButtons.forEach(btn => {
      disableMainWishlistElementTemporarily(btn);
    });

    try {
      const response = await fetch(this.defaultUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          'customer_id': this.customerId,
          'metaobject_type': this.objectType,
          'target_type': 'metaobject',
          'metaobject_id': objectId,
          'action': fixAction ? fixAction : isCurrentlyFavorited ? 'remove' : 'add'
        })
      });

      const result = await response.json();

      if (!isRemoveAction && button._multilikesRequestSeq !== seq) {
        if (!response.ok) {
          console.error('Stale wishlist update failed:', result);
        }
        return;
      }
      
      if (response.ok) {
        if(isRemoveAction){
          const itemElement = button.closest('.wishlist-item');
          const wrapperElement = itemElement?.closest('.wishlist-item-wrapper');
          const previousPage = this.currentPage;
          const removedFromState = this.metaobjects.some(item => item.id === objectId);
        
          if (wrapperElement) {
            wrapperElement.remove();
          } else if (itemElement) {
            itemElement.remove();
          }
          this.metaobjects = this.metaobjects.filter(item => item.id !== objectId);
          const favoriteIndex = this.favoritedIds.indexOf(objectId);
          if (favoriteIndex > -1) {
            this.favoritedIds.splice(favoriteIndex, 1);
          }

          if (removedFromState) {
            this.totalCount = Math.max(0, this.totalCount - 1);
          }
          const newTotalPages = Math.ceil(this.totalCount / this.itemsPerPage);
          const remainingItems = this.gridElement.querySelectorAll('.wishlist-item, .wishlist-item-wrapper');
          const isPageEmpty = remainingItems.length === 0;
          
          if (this.totalCount === 0) {
            this.currentPage = 1;
            this.totalPages = 0;
            this.pageInfo.hasNextPage = false;
            this.pageInfo.hasPreviousPage = false;
            this.pageCursors = {};
            this.metaobjects = [];
            this.updateTotalCount();
            this.renderPagination();
            this.render();
          } else {
            this.totalPages = newTotalPages;
            
            let targetPage = this.currentPage;
            if (this.currentPage > this.totalPages) {
              targetPage = this.totalPages;
            }
          
            if (isPageEmpty && targetPage > 1) {
              targetPage = targetPage - 1;
            }
            
            if (isPageEmpty || targetPage !== previousPage) {
              this.pageCursors = {};
              this.currentPage = previousPage;
              await this.resetAndMove(targetPage);
            } else {
              this.pageInfo.hasNextPage = this.currentPage < this.totalPages;
              this.pageInfo.hasPreviousPage = this.currentPage > 1;
              this.updateTotalCount();
              this.renderPagination();
              this.render();
            }
          }
        }else{
          const payload = result?.data || {};
          const resolvedFavoriteState = typeof payload.isInWishlist === 'boolean'
            ? payload.isInWishlist
            : nextFavoriteState;
          let updatedFavoriteCount = this.resolveFavoriteCountFromPayload(payload);
          const currentMetaobject = this.metaobjects
            ? this.metaobjects.find(item => item.id === objectId)
            : null;

          this.setFavoritedState(objectId, resolvedFavoriteState);

          if (currentMetaobject) {
            if (updatedFavoriteCount !== null) {
              currentMetaobject.favoriteCount = updatedFavoriteCount;
            } else if (resolvedFavoriteState !== nextFavoriteState) {
              updatedFavoriteCount = this.adjustFavoriteCountAfterToggle(
                currentMetaobject,
                nextFavoriteState,
                resolvedFavoriteState
              );
            } else {
              updatedFavoriteCount = currentMetaobject.favoriteCount;
            }
            currentMetaobject.isInWishlist = resolvedFavoriteState;
          }
          
          this.lastUpdated = new Date();
          
          this.updateButtonUI(
            button,
            resolvedFavoriteState,
            metaobjectDisplayName,
            updatedFavoriteCount
          );
        }
      } else {
        throw new Error(result.error || '不明なエラー');
      }
    } catch (error) {
      if (!isRemoveAction && button._multilikesRequestSeq !== seq) {
        console.error('Stale wishlist update failed:', error);
        return;
      }

      if (!isRemoveAction) {
        this.setFavoritedState(objectId, isCurrentlyFavorited);
        if (metaobject) {
          metaobject.isInWishlist = isCurrentlyFavorited;
          metaobject.favoriteCount = previousFavoriteCount;
        }
        this.updateButtonUI(
          button,
          isCurrentlyFavorited,
          metaobjectDisplayName,
          previousFavoriteCount
        );
      } else if (!this.container.contains(button)) {
        return;
      }

      alert('エラーが発生しました。時間をおいて再度お試しください。');
      console.error('Error:', error);
    }
  }
  
  clearData() {
    this.favoritedIds = [];
    this.metaobjects = [];
    this.loaded = false;
    this.loading = false;
    this.lastUpdated = null;
    this.currentPage = 1;
    this.totalPages = 0;
    this.pageInfo = {
      hasNextPage: false,
      hasPreviousPage: false,
      startCursor: null,
      endCursor: null
    };
    this.pageCursors = {};
  }
  
  getStatus() {
    return {
      exists: true,
      loaded: this.loaded,
      loading: this.loading,
      itemCount: this.favoritedIds.length,
      lastUpdated: this.lastUpdated,
      currentPage: this.currentPage,
      totalPages: this.totalPages
    };
  }

  async goToPage(targetPage) {
    if (targetPage < 1 || targetPage > this.totalPages || targetPage === this.currentPage) {
      return;
    }
    
    const currentPage = this.currentPage;
    const pageDistance = Math.abs(targetPage - currentPage);
    
    if (targetPage === 1) {
      await this.directPageMove(targetPage);
      return;
    }
    
    if (this.pageCursors[targetPage]) {
      await this.directPageMoveWithCursor(targetPage, this.pageCursors[targetPage]);
      return;
    }
    
    if (pageDistance === 1) {
      await this.directPageMove(targetPage);
    } else if (pageDistance <= 5) {
      await this.progressivePageMove(targetPage);
    } else {
      await this.resetAndMove(targetPage);
    }
  }

  async directPageMoveWithCursor(targetPage, cursor) {
    this.currentPage = targetPage;
    await this.fetchWishlistData(true, cursor);
  }

  handleCursorError() {
    console.warn('カーソーエラーを検出しました。ページを復旧します。');
    
    this.hideLoading();
    
    if (this.gridElement) {
      this.gridElement.innerHTML = `
        <div class="wishlist-cursor-error">
          <p>表示するアイテムが削除されました。1ページに戻ります...</p>
          <p class="wishlist-cursor-error__countdown">3秒後に自動的にリロードされます</p>
        </div>
      `;
    }
    
    this.pageCursors = {};
    
    this.startCountdown(() => {
      this.currentPage = 1;
      window.location.reload();
    });
  }

  startCountdown(callback) {
    let count = 3;
    const countdownElement = this.gridElement?.querySelector('.wishlist-cursor-error__countdown');
    
    const updateCountdown = () => {
      if (countdownElement) {
        countdownElement.textContent = `${count}秒後に自動的にリロードされます`;
      }
      
      if (count <= 0) {
        callback();
      } else {
        count--;
        setTimeout(updateCountdown, 1000);
      }
    };
    
    setTimeout(updateCountdown, 1000);
  }

  setPaginationType(type) {
    if (type === 'simple' || type === 'detailed') {
      this.paginationType = type;
      this.renderPagination();
    } else {
      console.warn('Invalid pagination type. Use "simple" or "detailed".');
    }
  }

  getPaginationType() {
    return this.paginationType;
  }

  createLoadingOverlay() {
    this.removeLoadingOverlay();
    
    if (!this.gridElement) return;
    
    this.loadingOverlay = document.createElement('div');
    this.loadingOverlay.className = 'wishlist-loading-overlay';
    
    const loadingContent = document.createElement('div');
    loadingContent.className = 'wishlist-loading-overlay__content';
    
    const spinner = document.createElement('div');
    spinner.className = 'wishlist-loading-overlay__spinner';
    
    const text = document.createElement('div');
    text.className = 'wishlist-loading-overlay__text';
    text.textContent = this.texts.loading || '読込中...';
    
    loadingContent.appendChild(spinner);
    loadingContent.appendChild(text);
    this.loadingOverlay.appendChild(loadingContent);
    
    this.gridElement.style.position = 'relative';
    this.gridElement.appendChild(this.loadingOverlay);
  }

  removeLoadingOverlay() {
    if (this.loadingOverlay && this.loadingOverlay.parentNode) {
      this.loadingOverlay.parentNode.removeChild(this.loadingOverlay);
      this.loadingOverlay = null;
    }
  }

  async directPageMove(targetPage) {
    const currentPage = this.currentPage;
    let cursor = null;
    
    if (targetPage === currentPage + 1) {
      cursor = this.pageInfo.endCursor;
    } else if (targetPage === currentPage - 1) {
      if (targetPage === 1) {
        cursor = null;
      } else if (this.pageCursors[targetPage]) {
        cursor = this.pageCursors[targetPage];
      } else {
        await this.resetAndMove(targetPage);
        return;
      }
    }
    
    this.currentPage = targetPage;
    await this.fetchWishlistData(true, cursor);
  }

  async progressivePageMove(targetPage) {
    const currentPage = this.currentPage;
    const direction = targetPage > currentPage ? 1 : -1;
    
    this.showLoading();
    
    try {
      let tempPage = currentPage;
      
      while (tempPage !== targetPage) {
        tempPage += direction;
        
        let cursor = null;
        if (direction === 1) {
          if (this.pageInfo.endCursor) {
            cursor = this.pageInfo.endCursor;
          } else if (this.pageCursors[tempPage]) {
            cursor = this.pageCursors[tempPage];
          } else {
            await this.resetAndMove(targetPage);
            return;
          }
        } else {
          if (tempPage === 1) {
            cursor = null;
          } else if (this.pageCursors[tempPage]) {
            cursor = this.pageCursors[tempPage];
          } else {
            await this.resetAndMove(targetPage);
            return;
          }
        }
        
                 this.currentPage = tempPage;
         
         const shouldRender = (tempPage === targetPage);
         await this.fetchWishlistData(shouldRender, cursor);
      }
    } catch (error) {
      await this.resetToFirstPage();
    }
  }

  async resetAndMove(targetPage) {
    
    await this.resetToFirstPage();
    
    if (targetPage === 1) {
      return;
    }
    
    await this.progressivePageMove(targetPage);
  }

  async resetToFirstPage() {
    this.currentPage = 1;
    this.pageCursors = {};
    await this.fetchWishlistData(true, null);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  WishlistSection.initAllSections();
});


class ProductWishlistSection {
  static sections = new WeakMap();
  
  constructor(container) {
    this.container = container;
    this.blockId = container.dataset.blockId;
    
    this.currentPage = 1;
    this.totalPages = 0;
    this.pageInfo = {
      hasNextPage: false,
      hasPreviousPage: false,
      startCursor: null,
      endCursor: null
    };
    
    const configScript = document.querySelector(`script[data-wishlist-config="${this.blockId}"]`);
    if (!configScript) {
      console.error(`Config not found for block: ${this.blockId}`);
      this.showError('設定が見つかりません');
      return;
    }
    
    try {
      this.config = JSON.parse(configScript.textContent);
      
      this.customerId = this.config.customerId;
      this.defaultUrl = this.config.defaultUrl;
      this.itemsPerPage = this.config.itemsPerPage || 48;
      
      if (this.config.texts === "global" && window.multilikesConfig?.texts) {
        this.texts = window.multilikesConfig.texts;
      } else if (typeof this.config.texts === 'object') {
        this.texts = this.config.texts;
      } else {
        this.texts = {
          loading: '読込中..',
          empty: 'お気に入りの商品がありません',
          error: '商品データの読み込み中にエラーが発生しました',
          removeProduct: '削除',
          productRemoved: '商品を削除しました'
        };
      }
    } catch (error) {
      console.error('Invalid JSON config:', error);
      this.showError('設定の形式が正しくありません');
      return;
    }
    
    this.gridElement = container.querySelector('.wishlist-grid');
    
    this.createPaginationElements();
    
    this.products = [];
    this.loading = false;
    this.loaded = false;
    
    this.setupEventListeners();
    this.init();
  }
  
  createPaginationElements() {
    const elements = WishlistUtils.createPaginationElements(this.container, this.texts.loading);
    this.loadingElement = elements.loadingElement;
    this.paginationElement = elements.paginationElement;
  }
  
  showLoading() {
    if (this.loadingElement) this.loadingElement.style.display = 'block';
    if (this.paginationElement) this.paginationElement.style.display = 'none';
  }
  
  hideLoading() {
    if (this.loadingElement) this.loadingElement.style.display = 'none';
    if (this.paginationElement) this.paginationElement.style.display = 'flex';
  }
  
  showError(message) {
    this.hideLoading();
    if (this.gridElement) {
      this.gridElement.innerHTML = `<div class="wishlist-error">${message}</div>`;
    }
  }
  
  setupEventListeners() {
    this.gridElement?.addEventListener('click', (e) => {
      const removeButton = e.target.closest('.wishlist-item__favorite-remove-btn');
      if (removeButton) {
        e.preventDefault();
        const variantId = removeButton.dataset.variantId;
        const productId = removeButton.dataset.productId;
        this.removeProduct(variantId, productId);
        return;
      }
      
      if (e.target.classList.contains('product-wishlist-item__add-to-cart')) {
        e.preventDefault();
        const variantId = e.target.dataset.variantId;
        this.addToCart(variantId, e.target);
      }
      
      if (e.target.classList.contains('product-wishlist-item__buy-now')) {
        e.preventDefault();
        const variantId = e.target.dataset.variantId;
        this.buyNow(variantId, e.target);
      }
    });
    
    this.paginationElement?.addEventListener('click', (e) => {
        e.preventDefault();
      const link = e.target.closest('a');
      if (link && !link.classList.contains('disabled')) {
        const page = parseInt(link.dataset.page);
        if (page && page !== this.currentPage) this.goToPage(page);
      }
    });
  }
  
  init() {
    this.fetchProducts();
  }
  
  extractNumericId(gid) {
    return WishlistUtils.extractNumericId(gid);
  }

  createProductItemElement(product) {
    const itemElement = document.createElement('div');
    itemElement.className = 'product-wishlist-item';
    const numericVariantId = this.extractNumericId(product.id);
    const numericProductId = this.extractNumericId(product.productId);
    itemElement.dataset.variantId = numericVariantId;
    if (numericProductId) {
      itemElement.dataset.productId = numericProductId;
    }
    
    const imageContainer = document.createElement('div');
    imageContainer.className = 'product-wishlist-item__image';
    
    if (product.image) {
      const imageLink = document.createElement('a');
      imageLink.href = `/products/${product.productHandle}`;
      imageLink.className = 'product-wishlist-item__image-link';
      
      const img = document.createElement('img');
      img.src = product.image;
      img.alt = product.title || '';
      img.loading = 'lazy';
      
      imageLink.appendChild(img);
      imageContainer.appendChild(imageLink);
    } else {
      const placeholder = document.createElement('div');
      placeholder.className = 'product-wishlist-item__image-placeholder';
      placeholder.textContent = 'No Image';
      imageContainer.appendChild(placeholder);
    }
    
    itemElement.appendChild(imageContainer);
    
    const removeButton = document.createElement('button');
    removeButton.className = 'wishlist-item__favorite-remove-btn';
    removeButton.dataset.variantId = numericVariantId;
    if (numericProductId) {
      removeButton.dataset.productId = numericProductId;
    }
    removeButton.setAttribute('aria-label', `${product.title}を削除`);
    itemElement.appendChild(removeButton);
    
    const infoContainer = document.createElement('div');
    infoContainer.className = 'product-wishlist-item__info';
    
    if (product.vendor && this.config.showVendor !== false) {
      const vendor = document.createElement('div');
      vendor.className = 'product-wishlist-item__vendor';
      vendor.textContent = product.vendor;
      infoContainer.appendChild(vendor);
    }
    
    const title = document.createElement('h3');
    title.className = 'product-wishlist-item__title';
    const titleLink = document.createElement('a');
    titleLink.href = `/products/${product.productHandle}`;
    titleLink.textContent = product.productTitle || product.title;
    title.appendChild(titleLink);
    infoContainer.appendChild(title);
    
    if (product.variantTitle && product.variantTitle !== 'Default Title') {
      const variant = document.createElement('div');
      variant.className = 'product-wishlist-item__variant';
      variant.textContent = product.variantTitle;
      infoContainer.appendChild(variant);
    }
    
    const priceContainer = document.createElement('div');
    priceContainer.className = 'product-wishlist-item__price';
    
    const currentPrice = document.createElement('span');
    currentPrice.className = 'product-wishlist-item__price-current';
    currentPrice.textContent = product.price;
    priceContainer.appendChild(currentPrice);
    
    if (product.compareAtPrice && product.compareAtPrice !== product.price) {
      const comparePrice = document.createElement('span');
      comparePrice.className = 'product-wishlist-item__price-compare';
      comparePrice.textContent = product.compareAtPrice;
      priceContainer.appendChild(comparePrice);
    }
    
    infoContainer.appendChild(priceContainer);
    
    // ノベルティは商品ページで交換コードと交換済みの判定を通すため、お気に入りから直接カートに入れさせない(Issue #104)
    const productTags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map((tag) => tag.trim());
    if(!(productTags.includes('favorite_noaddtocart') || productTags.includes('ノベルティ'))) {
      const actionButtons = document.createElement('div');
      actionButtons.className = 'product-wishlist-item__actions';
      
      const saleStatus = this.getProductSaleStatus(product);
      
      if (saleStatus === 'available') {
        const addToCartBtn = document.createElement('button');
        addToCartBtn.className = 'product-wishlist-item__add-to-cart';
        addToCartBtn.dataset.variantId = numericVariantId;
        addToCartBtn.textContent = this.texts.addToCart || 'カートへ入れる';
        actionButtons.appendChild(addToCartBtn);
      } else {
        // const soldOutBtn = document.createElement('button');
        // soldOutBtn.className = 'product-wishlist-item__sold-out';
        // soldOutBtn.disabled = true;
        // soldOutBtn.textContent = this.texts.soldOut || '売り切れ';
        // actionButtons.appendChild(soldOutBtn);
      }
    
      infoContainer.appendChild(actionButtons);
    }

    itemElement.appendChild(infoContainer);
    
    return itemElement;
  }
  
  getProductSaleStatus(product) {
    if (product.available) {
      return 'available';
    }
    
    return 'sold_out';
  }
  
  render() {
    if (!this.gridElement) return;
    
    this.gridElement.innerHTML = '';
    
    this.updateTotalCount();
    
    if (this.products.length === 0) {
      this.gridElement.innerHTML = `${this.texts.empty}`;
      this.renderPagination();
      return;
    }
    
    this.products.forEach(product => {
      const itemElement = this.createProductItemElement(product);
      this.gridElement.appendChild(itemElement);
    });
    
    this.renderPagination();
  }
  
  updateTotalCount() {
    const contentWrapper = this.container.closest('.customer-wishlist-content');
    if (!contentWrapper) return;
    
    let countElement = contentWrapper.querySelector('.customer-wishlist-count');
    if (!countElement) {
      countElement = document.createElement('div');
      countElement.className = 'customer-wishlist-count';
      contentWrapper.insertBefore(countElement, this.container);
    }
    countElement.textContent = `登録数: ${this.totalCount || 0}件`;
  }
  
  renderPagination() {
    if (!this.paginationElement) return;
    
    this.paginationElement.innerHTML = '';
    
    if (this.totalPages <= 1) return;
    
    const ul = document.createElement('ul');
    ul.className = 'wishlist-pagination__list wishlist-pagination__list--simple';
    
    const prevButton = this.createPageLink(this.currentPage - 1, '‹', this.currentPage === 1);
    ul.appendChild(prevButton);
    
    const pageInfo = document.createElement('li');
    pageInfo.className = 'wishlist-pagination__item wishlist-pagination__page-info';
    const startItem = (this.currentPage - 1) * this.itemsPerPage + 1;
    const endItem = Math.min(this.currentPage * this.itemsPerPage, this.totalCount);
    const totalText = this.texts.paginationTotal || '件中';
    pageInfo.textContent = `${startItem}-${endItem} / ${this.totalCount}${totalText}`;
    ul.appendChild(pageInfo);
    
    const nextButton = this.createPageLink(this.currentPage + 1, '>', this.currentPage === this.totalPages);
    ul.appendChild(nextButton);
    
    this.paginationElement.appendChild(ul);
  }
  
  createPageLink(pageNumber, text, isDisabled = false) {
    return WishlistUtils.createPageLink(pageNumber, text, isDisabled);
  }
  
  async fetchProducts(cursor = null) {
    if (this.loading) return;
    
    this.loading = true;
    this.showLoading();
    
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('customer_id', this.customerId);
      queryParams.append('target_type', 'product');
      queryParams.append('mode', 'customer_wishlist');
      queryParams.append('limit', this.itemsPerPage.toString());
      
      if (cursor) {
        queryParams.append('after', cursor);
      }
      
      const requestUrl = `${this.defaultUrl}?${queryParams.toString()}`;
      const response = await fetch(requestUrl);
      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.error || 'Failed to fetch products');
      }
      
      this.products = result.data || [];
      this.totalCount = result.total || 0;
      this.totalPages = Math.ceil(this.totalCount / this.itemsPerPage);
      
      if (result.pageInfo) {
        this.pageInfo = result.pageInfo;
      }
      
      this.loaded = true;
      this.hideLoading();
      this.render();
      
    } catch (error) {
      console.error('Error fetching product wishlist:', error);
      this.hideLoading();
      this.showError(this.texts.error);
    } finally {
      this.loading = false;
    }
  }
  
  async removeProduct(variantId, productId) {
    const normalizedVariantId = this.extractNumericId(variantId);
    const normalizedProductId = this.extractNumericId(productId);
    if (!this.customerId || !normalizedVariantId || !normalizedProductId) return;
    
    const button = this.container.querySelector(
      `.wishlist-item__favorite-remove-btn[data-variant-id="${normalizedVariantId}"]`
    );
    if (button) {
      disableMainWishlistElementTemporarily(button);
    }
    
    try {
      const response = await fetch(this.defaultUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          'customer_id': this.customerId,
          'product_id': normalizedProductId,
          'variant_id': normalizedVariantId,
          'target_type': 'product',
          'action': 'remove'
        })
      });
      
      const result = await response.json();

      if (response.ok) {
        const currentPageItems = this.gridElement.querySelectorAll('.product-wishlist-item');
        const willBeEmpty = currentPageItems.length === 1;
        const hasPreviousPage = this.currentPage > 1;
        const hasNextPage = this.pageInfo.hasNextPage;
        
        const itemElement = this.gridElement.querySelector(
          `.product-wishlist-item[data-variant-id="${normalizedVariantId}"]`
        );
        const removedFromState = this.products.some(
          p => this.extractNumericId(p.id) === normalizedVariantId
        );
        if (itemElement) {
          itemElement.remove();
        }
        
        this.products = this.products.filter(
          p => this.extractNumericId(p.id) !== normalizedVariantId
        );
        
        if (removedFromState) {
          this.totalCount = Math.max(0, this.totalCount - 1);
        }
        this.totalPages = Math.ceil(this.totalCount / this.itemsPerPage);
        this.updateTotalCount();
        this.renderPagination();
        
        if (willBeEmpty && this.totalCount > 0) {
          if (hasPreviousPage && !hasNextPage) {
            this.currentPage--;
          }
          const cursor = this.currentPage > 1 ? String((this.currentPage - 1) * this.itemsPerPage) : null;
          await this.fetchProducts(cursor);
        } else if (this.totalCount === 0) {
          this.render();
        }
      } else {
        alert('エラーが発生しました: ' + (result.error || '不明なエラー'));
      }
    } catch (error) {
      console.error('Error removing product:', error);
      alert('エラーが発生しました。時間をおいて再度お試しください。');
    }
  }
  
  async goToPage(targetPage) {
    if (targetPage < 1 || targetPage > this.totalPages || targetPage === this.currentPage) {
      return;
    }
    
    this.currentPage = targetPage;
    
    const cursor = targetPage > 1 ? String((targetPage - 1) * this.itemsPerPage) : null;
    await this.fetchProducts(cursor);
  }
  
  async addToCart(variantId, button) {
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = '追加中...';
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });
      
      if (response.ok) {
        window.location.href = '/cart';
      } else {
        const errorData = await response.json();
        if (errorData.description && errorData.description.includes('stock')) {
          this.handleOutOfStock(button);
        } else {
          throw new Error(errorData.description || 'カート追加に失敗しました');
        }
      }
    } catch (error) {
      console.error('カート追加エラー:', error);
      button.textContent = 'エラー';
      button.classList.add('is-error');
      
      this.showErrorMessage(button.parentElement, 'カートへの追加に失敗しました');
      
      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove('is-error');
        button.disabled = false;
      }, 2000);
    }
  }
  
  async buyNow(variantId, button) {
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = '処理中...';
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });
      
      if (response.ok) {
        window.location.href = '/checkout';
      } else {
        const errorData = await response.json();
        if (errorData.description && errorData.description.includes('stock')) {
          this.handleOutOfStock(button);
        } else {
          throw new Error(errorData.description || '購入処理に失敗しました');
        }
      }
    } catch (error) {
      console.error('購入処理エラー:', error);
      button.textContent = originalText;
      button.disabled = false;
      
      this.showErrorMessage(button.parentElement, '購入処理に失敗しました');
    }
  }
  
  handleOutOfStock(button) {
    const actionContainer = button.parentElement;
    
    this.showErrorMessage(actionContainer, '申し訳ございません。この商品は在庫切れです。');
    
    actionContainer.innerHTML = '';
    
    // const soldOutBtn = document.createElement('button');
    // soldOutBtn.className = 'product-wishlist-item__sold-out';
    // soldOutBtn.disabled = true;
    // soldOutBtn.textContent = '売り切れ';
    // actionContainer.appendChild(soldOutBtn);
    
    const variantId = button.dataset.variantId;
    const normalizedVariantId = this.extractNumericId(variantId);
    const product = this.products.find(
      p => this.extractNumericId(p.id) === normalizedVariantId
    );
    if (product) {
      product.available = false;
    }
  }
  
  showErrorMessage(container, message) {
    const existingMessage = container.querySelector('.product-wishlist-item__error-message');
    if (existingMessage) existingMessage.remove();
    
    const messageElement = document.createElement('div');
    messageElement.className = 'product-wishlist-item__error-message';
    messageElement.textContent = message;
    container.appendChild(messageElement);
    setTimeout(() => messageElement.remove(), 3000);
  }
  
  static initByContainer(container) {
    if (!container) return null;
    if (container.dataset.initialized === 'true') {
      return ProductWishlistSection.sections.get(container);
    }
    container.dataset.initialized = 'true';
    const section = new ProductWishlistSection(container);
    ProductWishlistSection.sections.set(container, section);
    return section;
  }
  
  static initAllSections() {
    document.querySelectorAll('product-wishlist-section').forEach(ProductWishlistSection.initByContainer);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  ProductWishlistSection.initAllSections();
});


class ContentWishlistSection {
  static sections = new WeakMap();

  constructor(container) {
    this.container = container;
    this.blockId = container.dataset.blockId;
    this.targetType = container.dataset.targetType || 'article';
    this.currentPage = 1;
    this.totalPages = 0;
    this.items = [];
    this.loading = false;
    this.pageInfo = {
      hasNextPage: false,
      hasPreviousPage: false,
      startCursor: null,
      endCursor: null
    };
    this.gridElement = container.querySelector('.wishlist-grid');

    const configScript = document.querySelector(`script[data-wishlist-config="${this.blockId}"]`);
    if (!configScript) {
      console.error(`Config not found for block: ${this.blockId}`);
      this.showError('設定が見つかりません');
      return;
    }

    try {
      const config = JSON.parse(configScript.textContent);
      this.customerId = config.customerId;
      this.defaultUrl = config.defaultUrl;
      this.itemsPerPage = config.itemsPerPage || 48;
      this.texts = this.resolveTexts(config.texts);
      this.placeholderImageUrl = config.placeholderImageUrl || null;
    } catch (error) {
      console.error('Invalid JSON config for content wishlist:', error);
      this.showError('設定の形式が正しくありません');
      return;
    }

    this.createPaginationElements();
    this.setupEventListeners();
    this.init();
  }

  resolveTexts(configTexts) {
    if (configTexts === 'global' && window.multilikesConfig?.texts) {
      return window.multilikesConfig.texts || {};
    }
    if (typeof configTexts === 'object' && configTexts !== null) {
      return configTexts;
    }
    return {
      loading: '読込中..',
      empty: 'お気に入りがありません',
      error: 'データの読み込み中にエラーが発生しました',
      detail_url_text: '詳細ページへ',
      removeFavorites: 'お気に入りから削除',
      remove_favorite: 'お気に入りから削除',
      favorite_count_label: 'お気に入り数'
    };
  }

  formatDate(dateString) {
    return WishlistUtils.formatDate(dateString);
  }

  init() {
    this.fetchItems();
  }

  createPaginationElements() {
    const elements = WishlistUtils.createPaginationElements(this.container, this.texts.loading);
    this.loadingElement = elements.loadingElement;
    this.paginationElement = elements.paginationElement;
  }

  showLoading() {
    if (this.loadingElement) this.loadingElement.style.display = 'block';
    if (this.paginationElement) this.paginationElement.style.display = 'none';
  }

  hideLoading() {
    if (this.loadingElement) this.loadingElement.style.display = 'none';
    if (this.paginationElement) this.paginationElement.style.display = 'flex';
  }
	
  setupEventListeners() {
    this.gridElement?.addEventListener('click', (event) => {
      const removeSelectors = [
        '.collection-wishlist-item__remove-link',
        '.page-wishlist-item__remove-link',
        '.article-wishlist-item__remove-link',
        '.wishlist-item__favorite-remove-btn'
      ];
      
      for (const selector of removeSelectors) {
        const removeElement = event.target.closest(selector);
        if (removeElement) {
        event.preventDefault();
          const objectId = removeElement.dataset.objectId;
          if (objectId) this.removeItem(objectId, removeElement);
          return;
        }
      }
    });

    this.paginationElement?.addEventListener('click', (e) => {
      e.preventDefault();
      const link = e.target.closest('a');
      if (link && !link.classList.contains('disabled')) {
        const page = parseInt(link.dataset.page, 10);
        if (page && page !== this.currentPage) this.goToPage(page);
      }
    });
  }

  async fetchItems(cursor = null) {
    if (this.loading) return;
    this.loading = true;
    this.showLoading();

    try {
      const queryParams = new URLSearchParams();
      if (this.customerId) {
        queryParams.append('customer_id', this.customerId);
      }
      queryParams.append('target_type', this.targetType);
      queryParams.append('mode', 'customer_wishlist');
      queryParams.append('limit', this.itemsPerPage.toString());
      if (cursor) {
        queryParams.append('after', cursor);
      }

      const requestUrl = `${this.defaultUrl}?${queryParams.toString()}`;
      const response = await fetch(requestUrl);
      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to fetch items');
      }

      this.items = result.data || [];
      this.totalCount = result.total || 0;
      this.totalPages = Math.ceil(this.totalCount / this.itemsPerPage);
      if (result.pageInfo) {
        this.pageInfo = result.pageInfo;
      }

      this.render();
      this.hideLoading();
    } catch (error) {
      console.error('Error fetching content wishlist:', error);
      this.showError(this.texts.error || 'データの取得に失敗しました');
    } finally {
      this.loading = false;
    }
  }

  render() {
    if (!this.gridElement) return;
    this.gridElement.innerHTML = '';

    this.updateTotalCount();

    if (!this.items || this.items.length === 0) {
      this.gridElement.innerHTML = `${this.texts.empty || 'お気に入りがありません'}`;
      this.renderPagination();
      return;
    }

    this.items.forEach((item) => {
      try {
      const element = this.createItemElement(item);
      if (element) {
        this.gridElement.appendChild(element);
        }
      } catch (error) {
        console.error('Error creating item element:', error, item);
      }
    });

    this.renderPagination();
  }

  updateTotalCount() {
    const contentWrapper = this.container.closest('.customer-wishlist-content');
    if (!contentWrapper) return;
    
    let countElement = contentWrapper.querySelector('.customer-wishlist-count');
    if (!countElement) {
      countElement = document.createElement('div');
      countElement.className = 'customer-wishlist-count';
      contentWrapper.insertBefore(countElement, this.container);
    }
    countElement.textContent = `登録数: ${this.totalCount || 0}件`;
  }

  createItemElement(item) {
    if (!item) return null;

    if (this.targetType === 'collection' || this.targetType === 'page') {
      const wrapper = document.createElement('div');
      const itemClass = this.targetType === 'collection' ? 'collection-wishlist-item' : 'page-wishlist-item';
      wrapper.className = itemClass;
      if (item.id) {
        wrapper.dataset.itemId = item.id;
      }

      if (item.url && item.title) {
        const mainLink = document.createElement('a');
        mainLink.href = item.url;
        const linkClass = this.targetType === 'collection' ? 'collection-wishlist-item__link' : 'page-wishlist-item__link';
        mainLink.className = linkClass;
        mainLink.textContent = item.title;
        wrapper.appendChild(mainLink);
      }

      const removeLink = document.createElement('a');
      removeLink.href = '#';
      const removeLinkClass = this.targetType === 'collection' ? 'collection-wishlist-item__remove-link' : 'page-wishlist-item__remove-link';
      removeLink.className = removeLinkClass;
      if (item.id) {
        removeLink.dataset.objectId = item.id;
      }
      const removeText = (this.texts && this.texts.remove_favorite) ? this.texts.remove_favorite : 'お気に入りから削除';
      const iconClass = this.targetType === 'collection' ? 'collection-wishlist-item__remove-icon' : 'page-wishlist-item__remove-icon';
      const textClass = this.targetType === 'collection' ? 'collection-wishlist-item__remove-text' : 'page-wishlist-item__remove-text';
      removeLink.innerHTML = '<span class="' + iconClass + '"></span><span class="' + textClass + '">' + removeText + '</span>';
      const ariaLabelTarget = item.title || (this.targetType === 'collection' ? 'このコレクション' : 'このページ');
      removeLink.setAttribute('aria-label', `${ariaLabelTarget}を削除`);
      wrapper.appendChild(removeLink);

      return wrapper;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'article-wishlist-item';
    wrapper.dataset.itemId = item.id;

      const imageContainer = document.createElement('div');
      imageContainer.className = 'article-wishlist-item__image';
      
      const imageLink = document.createElement('a');
      imageLink.href = item.url || '#';
      imageLink.className = 'article-wishlist-item__image-link';
      
      const img = document.createElement('img');
    img.src = item.image || this.placeholderImageUrl || '';
      img.alt = item.title || '';
      img.loading = 'lazy';
      
      imageLink.appendChild(img);
      imageContainer.appendChild(imageLink);
    
      wrapper.appendChild(imageContainer);

    const info = document.createElement('div');
    info.className = 'article-wishlist-item__info';

    if (item.title) {
      const title = document.createElement('h3');
      title.className = 'article-wishlist-item__title';
      
      const titleLink = document.createElement('a');
      titleLink.href = item.url || '#';
      titleLink.textContent = item.title;
      
      title.appendChild(titleLink);
      info.appendChild(title);
    }

    if (item.publishedAt) {
      const publishedAt = document.createElement('div');
      publishedAt.className = 'article-wishlist-item__published-at';
      publishedAt.textContent = this.formatDate(item.publishedAt);
      info.appendChild(publishedAt);
    }

    if (item.body) {
      const excerpt = document.createElement('div');
      excerpt.className = 'article-wishlist-item__excerpt';
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = item.body;
      const plainText = tempDiv.textContent || tempDiv.innerText || '';
      excerpt.textContent = plainText;
      info.appendChild(excerpt);
    }

    const removeLink = document.createElement('a');
    removeLink.href = '#';
    removeLink.className = 'article-wishlist-item__remove-link';
    if (item.id) {
      removeLink.dataset.objectId = item.id;
    }
    const removeText = (this.texts && this.texts.remove_favorite) ? this.texts.remove_favorite : 'お気に入りから削除';
    removeLink.innerHTML = '<span class="article-wishlist-item__remove-icon"></span><span class="article-wishlist-item__remove-text">' + removeText + '</span>';
    const ariaLabelTarget = item.title || 'この記事';
    removeLink.setAttribute('aria-label', `${ariaLabelTarget}を削除`);
    info.appendChild(removeLink);

    wrapper.appendChild(info);
    
    return wrapper;
  }

  renderPagination() {
    if (!this.paginationElement) return;
    this.paginationElement.innerHTML = '';
    if (this.totalPages <= 1) return;

    const ul = document.createElement('ul');
    ul.className = 'wishlist-pagination__list wishlist-pagination__list--simple';

    ul.appendChild(this.createPageLink(this.currentPage - 1, '<', this.currentPage === 1));

    const pageInfo = document.createElement('li');
    pageInfo.className = 'wishlist-pagination__item wishlist-pagination__page-info';
    const startItem = (this.currentPage - 1) * this.itemsPerPage + 1;
    const endItem = Math.min(this.currentPage * this.itemsPerPage, this.totalCount);
    const totalText = this.texts.paginationTotal || '件中';
    pageInfo.textContent = `${startItem}-${endItem} / ${this.totalCount}${totalText}`;
    ul.appendChild(pageInfo);

    ul.appendChild(this.createPageLink(this.currentPage + 1, '>', this.currentPage === this.totalPages));
    this.paginationElement.appendChild(ul);
  }

  createPageLink(pageNumber, text, isDisabled = false) {
    return WishlistUtils.createPageLink(pageNumber, text, isDisabled);
  }

  async goToPage(targetPage) {
    if (targetPage < 1 || targetPage > this.totalPages || targetPage === this.currentPage) {
      return;
    }

    this.currentPage = targetPage;
    const cursor = targetPage > 1 ? String((targetPage - 1) * this.itemsPerPage) : null;
    await this.fetchItems(cursor);
  }

  async removeItem(objectId, buttonOrLink) {
    if (!this.customerId || !objectId) {
      return;
    }

    if (buttonOrLink) {
      disableMainWishlistElementTemporarily(buttonOrLink);
    }

    try {
      const idParam = this.targetType === "article" ? "article_id" : this.targetType === "page" ? "page_id" : "collection_id";
      const response = await fetch(this.defaultUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          customer_id: this.customerId,
          [idParam]: objectId,
          target_type: this.targetType,
          action: 'remove'
        })
      });

      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.error || 'Failed to remove item');
      }

      const itemElement = buttonOrLink.closest('.article-wishlist-item, .collection-wishlist-item, .page-wishlist-item');
      const removedFromState = this.items.some(item => item.id === objectId);
      if (itemElement) {
        itemElement.remove();
      }
      this.items = this.items.filter(item => item.id !== objectId);

      if (removedFromState) {
        this.totalCount = Math.max(0, this.totalCount - 1);
      }
      const newTotalPages = Math.ceil(this.totalCount / this.itemsPerPage);
      
      const remainingItems = this.gridElement.querySelectorAll('.article-wishlist-item, .collection-wishlist-item, .page-wishlist-item');
      const isPageEmpty = remainingItems.length === 0;
      
      const previousPage = this.currentPage;

      if (this.totalCount === 0) {
        this.currentPage = 1;
        this.totalPages = 0;
        this.pageInfo.hasNextPage = false;
        this.pageInfo.hasPreviousPage = false;
        this.updateTotalCount();
        this.renderPagination();
        this.render();
      } else {
        this.totalPages = newTotalPages;
        
        let targetPage = this.currentPage;
        if (this.currentPage > this.totalPages) {
          targetPage = this.totalPages;
        }
        
        if (isPageEmpty && targetPage > 1) {
          targetPage = targetPage - 1;
        }
        
        if (isPageEmpty || targetPage !== previousPage) {
          this.currentPage = previousPage;
          const cursor = targetPage > 1 ? String((targetPage - 1) * this.itemsPerPage) : null;
          this.currentPage = targetPage;
          await this.fetchItems(cursor);
        } else {
          this.pageInfo.hasNextPage = this.currentPage < this.totalPages;
          this.pageInfo.hasPreviousPage = this.currentPage > 1;
          this.updateTotalCount();
          this.renderPagination();
          this.render();
        }
      }
    } catch (error) {
      console.error('Failed to remove wishlist item:', error);
      alert(this.texts.error || 'エラーが発生しました。');
    } finally {
    }
  }

  showError(message) {
    this.hideLoading();
    if (this.gridElement) {
      this.gridElement.innerHTML = `<div class="wishlist-error">${message}</div>`;
    }
  }

  static initByContainer(container) {
    if (!container) return null;
    if (container.dataset.initialized === 'true') {
      return ContentWishlistSection.sections.get(container);
    }
    container.dataset.initialized = 'true';
    const section = new ContentWishlistSection(container);
    ContentWishlistSection.sections.set(container, section);
    return section;
  }

  static initAllSections() {
    const selectors = ['article-wishlist-section', 'page-wishlist-section', 'collection-wishlist-section'];
    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach(ContentWishlistSection.initByContainer);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  ContentWishlistSection.initAllSections();
});



document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('customer-wishlist');
  if (!container) return;

  const tabs = container.querySelectorAll('.customer-wishlist-tab');
  const contents = container.querySelectorAll('.customer-wishlist-content');

  function initializeWishlistsInContent(content) {
    content.querySelectorAll('metaobject-wishlist').forEach((el) => {
      if (el.dataset.initialized !== 'true') WishlistSection.initByObjectType(el);
    });
    content.querySelectorAll('product-wishlist-section').forEach((el) => {
      if (el.dataset.initialized !== 'true') ProductWishlistSection.initByContainer(el);
    });
    content.querySelectorAll('article-wishlist-section, page-wishlist-section, collection-wishlist-section').forEach((el) => {
      if (el.dataset.initialized !== 'true') ContentWishlistSection.initByContainer(el);
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', function () {
      const targetTab = this.dataset.tab;
      tabs.forEach((t) => t.classList.remove('is-active'));
      this.classList.add('is-active');

      contents.forEach((content) => {
        content.classList.remove('is-active');
        if (content.dataset.content === targetTab) {
          content.classList.add('is-active');
          initializeWishlistsInContent(content);
        }
      });
    });
  });
  
  const activeContent = container.querySelector('.customer-wishlist-content.is-active');
  if (activeContent) initializeWishlistsInContent(activeContent);
});


class WishlistHeaderIcon {
  constructor(config) {
    this.config = config;
  }

  init() {
    if (!this.config?.enabled || !this.config?.wishlistPageUrl) return;

    if (document.querySelector('[data-ml-wishlist-link]')) return;

    const cartLink = this.findCartLink();
    if (!cartLink) return;

    const heartLink = this.createHeartLink();
    cartLink.parentNode.insertBefore(heartLink, cartLink);
  }

  findCartLink() {
    // 1. a[href] に /cart を含むリンクを検索（Dawn等の一般的なテーマ）
    const links = document.querySelectorAll('a[href*="/cart"]');
    for (const link of links) {
      const href = link.getAttribute('href') || '';
      if (/\/cart(\?|#|\/|$)/.test(href)) {
        return link;
      }
    }

    // 2. Horizonテーマ等: cart-drawer-component.cart-drawer の前に挿入
    const cartDrawer = document.querySelector('cart-drawer-component.cart-drawer');
    if (cartDrawer) return cartDrawer;

    return null;
  }

  createHeartLink() {
    const link = document.createElement('a');
    link.href = this.config.wishlistPageUrl;
    link.className = 'multilikes-header-icon';
    link.setAttribute('aria-label', 'お気に入り一覧');

    if (this.config.iconImageUrl) {
      const img = document.createElement('img');
      img.src = this.config.iconImageUrl;
      img.alt = 'お気に入り';
      img.className = 'multilikes-header-icon__img';
      link.appendChild(img);
    } else {
      link.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    }

    return link;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const headerIconConfig = window.multilikesConfig?.headerIcon;
  if (headerIconConfig) {
    new WishlistHeaderIcon(headerIconConfig).init();
  }
});
